import React, { useState, useEffect } from 'react'
import InputRange from 'react-input-range'
import 'react-input-range/lib/css/index.css'
import { useFilters } from '../../context/FiltersContext'
import { DimensionFilter } from "../../types/FiltersTypes"

interface Props {
  dimensions: DimensionFilter[]
}

export const DimensionFilters: React.FC<Props> = ({ dimensions }) => {
  const { activeDimensions, setActiveDimensions } = useFilters()
  const dimensionsMixMax = dimensions.reduce((minMax, dimension) => {
    minMax[dimension.subType] = {
      min: dimension.min,
      max: dimension.max
    }
    return minMax;
  }, {});

  const [currentDimensions, setCurrentDimensions] = useState(dimensionsMixMax);

  const handleChange = (dimension: DimensionFilter, values) => {
    setCurrentDimensions({
      ...currentDimensions,
      [dimension.subType]: values
    })
  }

  const handleChangeComplete = () => {
    setActiveDimensions(currentDimensions)
  }

  // active filters have been reset
  useEffect(() => {
    if (!activeDimensions.height && !activeDimensions.width && !activeDimensions.depth) {
      setCurrentDimensions(dimensionsMixMax)
    }
  }, [activeDimensions]);

  return (
    <>
      {dimensions.map(dimension =>
        <>
          <p className="refineby-rangetitle">{dimension.title}</p>
          <div className="refineby-rangewrap">
            <InputRange
              draggableTrack
              maxValue={parseFloat(dimension.max)}
              minValue={parseFloat(dimension.min)}
              value={{
                min: parseFloat(currentDimensions[dimension.subType].min),
                max: parseFloat(currentDimensions[dimension.subType].max),
              }}
              onChange={(values) => handleChange(dimension, values)}
              onChangeComplete={handleChangeComplete}
              formatLabel={(value) => `${value}cm`}
            />
          </div>
        </>
      )}
    </>
  )
}
